import { Icon } from 'leaflet';
//clickable icons
import basketball_icon from './Images/basketball.png';
import bruincard_icon from './Images/bruincard.png';
import camera_icon from './Images/camera.png';
import flag_pin_icon from './Images/flag-pin.png';
import football_icon from './Images/football.png';
import gavel_icon from './Images/gavel.png';
import house_icon from './Images/house.png';
import magazine_icon from './Images/magazine.png';
import microphone_icon from './Images/microphone.png';
import money_icon from './Images/money.png';
import police_siren_icon from './Images/police-siren.png';
import powell_cat_icon from './Images/powell-cat.png';
import robot_icon from './Images/robot.png';
import royce_hall_icon from './Images/royce-hall.png';
import soccer_ball_icon from './Images/soccer-ball.png';
import speakerphone_icon from './Images/speakerphone.png';
import uaw_sign_icon from './Images/uaw-sign.png';
import volleyball_icon from './Images/volleyball.png';
import voting_box_icon from './Images/voting-box.png';
import wifi_icon from './Images/wifi.png';
//non-clickable icons
// import backpack_icon from './Images/Backpack.png';
// import blue_coffee_cup_icon from './Images/Blue coffee cup.png';
// import db_logo_icon from './Images/DB logo.png';
// import green_coffee_cup_icon from './Images/Green coffee cup.png';
// import db_newspaper_icon from './Images/DB newspaper.png';
// import dice_icon from './Images/Dice.png';
// import epic_bag_2_icon from './Images/Epic bag 2.png';
// import epic_icon from './Images/Epic.png';
// import eraser_icon from './Images/Eraser.png';
// import globe_icon from './Images/Globe.png';
// import grad_cap_icon from './Images/Graduation cap.png';
// import group_15_icon from './Images/Group 15.png';
// import headphones_icon from './Images/headphones.png';
// import jersey_icon from './Images/Jersey.png';
// import joe_icon from './Images/Joe.png';
// import josie_icon from './Images/Josie.png';
// import lanyard_icon from './Images/Lanyard.png';
// import laptop_icon from './Images/Laptop.png';
// import meal_coupon_icon from './Images/meal coupon.png';
// import ncaa_trophy_icon from './Images/NCAA_TROPHY.png';
// import notebook_icon from './Images/notebook.png';
// import ollie_icon_icon from './Images/Ollie.png';
// import pamphlet_icon from './Images/Pamphlet.png';
// import pen_black_icon from './Images/Pen black.png';
// import pen_blue_icon from './Images/Pen blue.png';
// import plant_1_icon from './Images/Plant 1.png';
// import plant_2_icon from './Images/Plant 2.png';
// import plant_3_icon from './Images/Plant 3.png';
// import plant_4_icon from './Images/Plant 4.png';
// import plant_5_icon from './Images/Plant 5.png';
// import powell_cat_2_icon from './Images/Powell cat.png';
// import powell_library_icon from './Images/Powell library.png';
// import sandwich1_icon from './Images/sandwich-1.png';
// import sandwich_icon from './Images/sandwich.png';
// import scooter_icon from './Images/Scooter.png';
// import soccer_ball_2_icon from './Images/Soccer ball.png';
// import squirrel_icon from './Images/Squirrel.png';
// import starship_icon from './Images/Starship.png';
// import suzy_icon from './Images/Suzy.png';
// import theater_masks_icon from './Images/Theater masks.png';
// import tote_bag_icon from './Images/Tote bag.png';
// import ucla_flag_icon from './Images/UCLA flag.png';
// import water_bottle_icon from './Images/Water bottle.png';



// CLICKABLE ICONS
export const basketball = new Icon({
  iconUrl: basketball_icon,
  iconSize:   [60, 60],
  iconAnchor: [30, 30],
});

export const bruincard = new Icon({
  iconUrl: bruincard_icon,
  iconSize:   [60, 60],
  iconAnchor: [30, 30],
});

export const camera = new Icon({
  iconUrl: camera_icon,
  iconSize:   [60, 60],
  iconAnchor: [30, 30],
});

export const flag_pin = new Icon({
	  iconUrl: flag_pin_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const football = new Icon({
	  iconUrl: football_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const gavel = new Icon({
	  iconUrl: gavel_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const house = new Icon({
	  iconUrl: house_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const magazine = new Icon({
	  iconUrl: magazine_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const microphone = new Icon({
	  iconUrl: microphone_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const money = new Icon({
	  iconUrl: money_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const police_siren = new Icon({
	  iconUrl: police_siren_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const powell_cat = new Icon({
	  iconUrl: powell_cat_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const robot = new Icon({
	  iconUrl: robot_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const royce_hall = new Icon({
	  iconUrl: royce_hall_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const soccer_ball = new Icon({
	  iconUrl: soccer_ball_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const speakerphone = new Icon({
	  iconUrl: speakerphone_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const uaw_sign = new Icon({
	  iconUrl: uaw_sign_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const volleyball = new Icon({
	  iconUrl: volleyball_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const voting_box = new Icon({
	  iconUrl: voting_box_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

export const wifi = new Icon({
	  iconUrl: wifi_icon,
	  iconSize:   [60, 60],
	  iconAnchor: [30, 30],
});

// // NON-CLICKABLE ICONS
// export const backpack = new Icon({
// 	  iconUrl: backpack_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const blue_coffee_cup = new Icon({
// 	  iconUrl: blue_coffee_cup_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const db_logo = new Icon({
// 	  iconUrl: db_logo_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const green_coffee_cup = new Icon({
// 	  iconUrl: green_coffee_cup_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const db_newspaper = new Icon({
// 	  iconUrl: db_newspaper_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const dice = new Icon({
// 	  iconUrl: dice_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const epic_bag_2 = new Icon({
// 	  iconUrl: epic_bag_2_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const epic = new Icon({
// 	  iconUrl: epic_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const eraser = new Icon({
// 	  iconUrl: eraser_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const globe = new Icon({
// 	  iconUrl: globe_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const grad_cap = new Icon({
// 	  iconUrl: grad_cap_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const group_15 = new Icon({
// 	  iconUrl: group_15_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const headphones = new Icon({
// 	  iconUrl: headphones_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const jersey = new Icon({
// 	  iconUrl: jersey_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const joe = new Icon({
// 	  iconUrl: joe_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const josie = new Icon({
// 	  iconUrl: josie_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const lanyard = new Icon({
// 	  iconUrl: lanyard_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const laptop = new Icon({
// 	  iconUrl: laptop_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const meal_coupon = new Icon({
// 	  iconUrl: meal_coupon_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const ncaa_trophy = new Icon({
// 	  iconUrl: ncaa_trophy_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const notebook = new Icon({
// 	  iconUrl: notebook_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const ollie_icon = new Icon({
// 	  iconUrl: ollie_icon_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const pamphlet = new Icon({
// 	  iconUrl: pamphlet_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const pen_black = new Icon({
// 	  iconUrl: pen_black_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const pen_blue = new Icon({
// 	  iconUrl: pen_blue_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const plant_1 = new Icon({
// 	  iconUrl: plant_1_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const plant_2 = new Icon({
// 	  iconUrl: plant_2_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const plant_3 = new Icon({
// 	  iconUrl: plant_3_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const plant_4 = new Icon({
// 	  iconUrl: plant_4_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const plant_5 = new Icon({
// 	  iconUrl: plant_5_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const powell_cat_2 = new Icon({
// 	  iconUrl: powell_cat_2_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const powell_library = new Icon({
// 	  iconUrl: powell_library_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const sandwich1 = new Icon({
// 	  iconUrl: sandwich1_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const sandwich = new Icon({
// 	  iconUrl: sandwich_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const scooter = new Icon({
// 	  iconUrl: scooter_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const soccer_ball_2 = new Icon({
// 	  iconUrl: soccer_ball_2_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const squirrel = new Icon({
// 	  iconUrl: squirrel_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const starship = new Icon({
// 	  iconUrl: starship_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const suzy = new Icon({
// 	  iconUrl: suzy_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const theater_masks = new Icon({
// 	  iconUrl: theater_masks_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const tote_bag = new Icon({
// 	  iconUrl: tote_bag_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const ucla_flag = new Icon({
// 	  iconUrl: ucla_flag_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });

// export const water_bottle = new Icon({
// 	  iconUrl: water_bottle_icon,
// 	  iconSize:   [60, 60],
// 	  iconAnchor: [30, 30],
// });